import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteCid() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((cidId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/cid-catalog/${cidId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
